import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {EntitySchemaService} from '@catcore/services/entity-schema.service';
import {ActiveModal} from '@catmodules/widgets/slide-in-modal/utils/modal-ref';
import {buildFormControlsFromSchema} from '@catuiform/shared/form-builder';
import {isNullOrUndefined} from 'util';
import {EntitySchemaType} from '@catcore/utils/json-schema/entity-schema-to-json-schema';
import {LinkItem, StyleType} from '@catui/types';
import {GuiZoneService, NotificationsService} from "@catcore/services";

/** Provides a modal form to delete a gui zone child.
 * It will display the information of the GUI zone e.g.
 * name, short name and more.
 */
@Component({
  selector: 'catapp-delete-gui-zone',
  templateUrl: './delete-gui-zone.component.html',
  styleUrls: ['./delete-gui-zone.component.scss'],
})
export class DeleteGuiZoneComponent implements OnInit {

  @Output() afterDelete = new EventEmitter();

  /**
   * Returns the stored GUI zone entity containing all data from schema
   *
   * @returns {any}
   */
  @Input()
  get guiZoneEntity() {
    return this._guiZoneEntity;
  }

  /**
   * Sets the GUI zone entity containing all data defined in enitity schema.
   * Furthermore builds the form data from entity schema which is shown in slide in.
   *
   * @param value
   */
  set guiZoneEntity(value) {
    this._guiZoneEntity = value;
    if (!isNullOrUndefined(this._guiZoneEntity)) {
      const formCtrls = buildFormControlsFromSchema(this._formBuilder, this._schema, this._guiZoneEntity);
      this.form = this._formBuilder.group(formCtrls);
      if (this.form) {
        const formControlKeys = Object.keys(this._guiZoneEntity);
        const patchableValues = {};
        formControlKeys.forEach((formControlKey) => {
          patchableValues[formControlKey] = this._guiZoneEntity[formControlKey];
        });

        this.form.patchValue(patchableValues);
      }
    }
  }

  private _guiZoneEntity;
  private _schema;

  /**
   * Definition of data which will be shown including the form label.
   */
  labels = {
    name: 'Name',
    short_name: 'Short Name',
    type: 'Zone Type',
    zone_pa: 'Zone PA Group',
    icon_name: 'Icon Name',
  };

  form: FormGroup;
  styleType = StyleType;
  parent = false;
  affectedGuiZone = null;
  affectedList = null;

  /**
   * Constructor for delete gui zone component.
   *
   * @param {FormBuilder} _formBuilder Class used to build forms using entity schema
   * @param {ActiveModal} _activeModal Current active modal (most likely this one)
   * @param {NotificationsService} _notification Service setting notifications
   * @param {EntitySchemaService} _schemaService Service getting current schema definition
   * @param {GuiZoneService} _guiZoneService Service performing operations related to a GUI zone
   */
  constructor(private _formBuilder: FormBuilder,
              private _activeModal: ActiveModal,
              private _notification: NotificationsService,
              private _schemaService: EntitySchemaService,
              private _guiZoneService: GuiZoneService) {
    this._schema = _schemaService.getForEntityName(EntitySchemaType['GuiZones']);
  }

  ngOnInit() {
  }

  ngOnDestroy() {
  }

  parentChildLabel() {
    return (this.parent ? 'Parent' : 'Child');
  }

  /**
   * Callback for click on delete button. User is requested to confirm deleation.
   * Afterwards deletion of GUI zone is triggered.
   */
  deleteGuiZone() {
    const deleteGuiZone = confirm('Are you sure you want to delete this ' + this.parentChildLabel().toLowerCase() + ' gui zone?');
    if (deleteGuiZone) {
      const newList = this.removeZoneFromList(this.affectedList, this._guiZoneEntity);
      this._guiZoneService.saveList(this.affectedGuiZone, newList, this.parent)
        .subscribe(() => {
          this._notification.success('GUI Zone Deleted', 'GUI Zone was successfully removed as a ' + (this.parent ? 'parent' : 'child'));
          this.afterDelete.emit();
          this._activeModal.close();
        });
    }
  }

  /**
   * Closes the modal on user request
   */
  close() {
    this._activeModal.close();
  }

  /**
   * Removes the currently visible GUI zone from the existing list.
   *
   * @param oldList List before deletion
   * @param guiZone GUI zone to be deleted
   * @returns {any[]} New list without GUI zone to be deleted
   */
  removeZoneFromList(oldList, guiZone) {
    const result = [];
    oldList.forEach((listItem: LinkItem) => {
      if (listItem.label !== guiZone.name) {
        result.push(listItem);
      }
    });
    console.log('List after deletion: ' + JSON.stringify(result));
    return result;
  }

}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/models/gui-zone/components/delete-gui-zone/delete-gui-zone.component.ts